export default __webpack_public_path__ + "static/media/blog-img109.c40fb340.jpg";